export const integerWithCommas = (value: number) => {
  return Math.round(value).toLocaleString('en-US');
};

export const integersFormatter = (value: number) => {
  const rounded = integerWithCommas(value);
  const newRounded = rounded.split(',').join('.');
  if (value >= 1e12) {
    return `${newRounded.slice(0, -12)}T`;
  }
  if (value >= 1e9 && value < 1e12) {
    return `${newRounded.slice(0, -9)}B`;
  }
  if (value >= 1e7 && value < 1e9) {
    return `${newRounded.slice(0, -8)}M`;
  }
  if (value >= 1e6) {
    return `${newRounded.slice(0, -6)}M`;
  }
  if (value >= 1e4 && value < 1e6) {
    return `${rounded.slice(0, -4)}K`;
  }
  return Math.round(value).toLocaleString('en-US');
};
